<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="language !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.language.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
          <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>


    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'key'" [control]="form.get('key')" [type]="'input'" [label]="t('common.labels.key')" [edit]="inEdit" [basevalue]="language.key"></app-form-control>

      </div>
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')" [edit]="inEdit" [basevalue]="language.name"></app-form-control>

      </div>
    </div>

  </form>
</ng-container>
